import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '../session-storage/session-storage.service';

/**
 * Service of translation using ng2-translate.
 */
@Injectable({
  providedIn: 'root',
})
export class MultiLanguageService {
  public langSelected!: string;
  private langDefault = 'es';
  private translateService: TranslateService;

  /**
   * Constructor: set default language
   */
  constructor(
    private readonly sessionStorageSrv: SessionStorageService,
    translateService: TranslateService
  ) {
    this.translateService = translateService;
    this.translateService.setDefaultLang(this.langDefault);
  }

  /**
   * Initialize a language, first checks if has been setted in sessionStorage yet,
   * else set land by default.
   */
  public initialize(): string {
    if (this.langSelected) {
      return this.langSelected;
    }

    const lang = this.sessionStorageSrv.get('language');
    if (lang) {
      this.setLanguage(lang);
    } else {
      this.setLanguage(this.langDefault);
    }

    return this.langSelected;
  }

  /**
   * Get language selected
   */
  public getLanguage() {
    return this.langSelected;
  }

  /**
   * Set a language passed by param
   * @param language: string
   */
  public setLanguage(language: string) {
    this.sessionStorageSrv.set('language', language);
    this.langSelected = language;
    this.translateService.use(this.langSelected);
  }
}
